module.exports = __webpack_public_path__ + "static/media/wa.0c0b68d5.png";